'use client';

import { hasServiceWorkerSupport } from "@/src/util/webpush";
import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";

export default function WebPushServiceWorker(): React.ReactNode {
    const router = useRouter();

    const onServiceWorkerMessage = useCallback(
        (evt: MessageEvent) => {
            // console.log('got message:', evt.data);

            if (
                evt.data?.type === 'notificationClick'
                && typeof evt.data.url === 'string'
            ) {
                router.push(evt.data.url);
            }
        },
        [router],
    );

    useEffect(
        () => {
            if (!hasServiceWorkerSupport()) {
                return;
            }

            navigator.serviceWorker
                .register('/sw.js')
                .catch(
                    (err) => console.error('Error registering service worker:', err),
                );
        },
        [],
    );

    useEffect(
        () => {
            if (!hasServiceWorkerSupport()) {
                return;
            }

            const sw = navigator.serviceWorker;
            sw.addEventListener('message', onServiceWorkerMessage);

            return () => sw.removeEventListener('message', onServiceWorkerMessage);
        },
        [onServiceWorkerMessage],
    );

    return <></>;
}
